import { useEffect, useMemo, useRef, useState } from "react";
import useEffectOnce from "./useEffectOnce";
import { STORAGE_KEYS } from "../config";
import short from "short-uuid";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";

export default function useAuth() {
  const [userId, setUserId] = useState<string>();
  const [user, setUser] = useState<User | undefined>();
  const didInit = useRef(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user?.uid) {
        setUser(user);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffectOnce(() => {
    const userId = window.localStorage.getItem(STORAGE_KEYS.USER_ID);

    if (userId) {
      return setUserId(userId);
    }
    const newId = short.generate();
    window.localStorage.setItem(STORAGE_KEYS.USER_ID, newId);
    setUserId(newId);
  });

  const result = useMemo(
    () => ({ authUser: user, userId, loading: !userId || !user?.uid }),
    [user, userId]
  );

  useEffect(() => {
    if (didInit.current === false) {
      if (result.loading === false) {
        console.log("**************** useAuth ****************", {
          ...result,
          authUserId: result.authUser?.uid,
        });
        didInit.current = true;
      }
    }
  }, [result]);

  return result;
}
